export const ApiNames = {
  headerEnrichment: "enrichment",
  checkjcUser: "jc/checkUser",
  jcGetPlan: "jc/getPlan",
};
